import { createContext, useContext } from 'react'

export const AttributesDiffContext = createContext<Map<string, string> | null>(null)

export const useAttributeDiff = () => {
  return useContext(AttributesDiffContext)
}